<template>
  <div style="transition: 0.4s; box-shadow: 4px 8px 16px 4px rgba(135, 135, 135, 0.6); z-index: 999999;" class="w-1/4 flex-1 bg-white rounded-xl space-y-6 p-6" :class="`step${ nowStep }`">
    <p v-html="content"></p>
    <div class="tip-footer">
      <button
        :style="{ opacity: nowStep === 801 ? 1 : 0 }"
        class="hover:bg-blue-100 focus:outline-none rounded-xl px-4 py-1 text-blue-400 transition duration-500 ease-in-out border-blue-400 border-2"
        :disabled="nowStep === 1"
        @click="closeTips()"
      >
        {{closeTipsText}}
      </button>
      <button
        v-if="nowStep === 823"
        class="hover:bg-yellow-200 focus:outline-none rounded-xl px-4 py-1 text-blue-800 transition duration-500 ease-in-out border-yellow-400 border-2 bg-yellow-300"
        @click="next()"
      >
        {{finishText}}
      </button>
      <button
        v-else
        class="hover:bg-green-200 focus:outline-none rounded-xl px-4 py-1 text-white transition duration-500 ease-in-out border-green-400 border-2 bg-green-400"
        @click="next()"
      >
        {{nextText}}
      </button>

    </div>
  </div>
</template>

<script>
import * as contentData from '@/components/Tips/formGuideTips.json';

export default {
  name: 'FormGuideTips',
  props: {
    nowStep: {
      type: Number,
      default: 1
    },
    selectLang: {
      type: String
    }
  },
  data() {
    return {
      nextText: '下一步',
      finishText: '完成',
      closeTipsText: '跳過教學'
    }
  },
  computed: {
    content() {
      const data = contentData.default.filter(e => e.step === this.nowStep);
      let message;
      if (data.length > 0) {
        message = data[0].content_zh_TW;
        if(this.selectLang == 'en-US'){
          this.nextText = '下一步';
          this.finishText = '完成';
          this.closeTipsText = '跳过教学';

          message = data[0].content_zh_CN;
        }
        if(this.selectLang == 'en-US'){
          this.nextText = 'next';
          this.finishText = 'finish';
          this.closeTipsText = 'skip teaching';

          message = data[0].content_en_US;
        }
      } else {
        message = '';
      }
      return message;
    }
  },
  methods: {
    next() {
      this.$emit('nextStep');
      // this.nowStep = this.nowStep + 1;
    },
    closeTips() {
      this.$emit('closeTips');
    }
  }
};

</script>

<style lang="scss">
/*無效？*/
.tip-block {
  box-shadow: 4px 8px 16px 4px rgba(135, 135, 135, 0.6);
  z-index: 999999;
}

.step801 {
  position: absolute;
  top: 15vh;
  left: 40vw;
}

.step802 {
  position: absolute;
  top: 40vh;
  left: 66vw;
}

.step803 {
  position: absolute;
  top: 40vh;
  left: 25vw;
}

.step804 {
  position: absolute;
  top: 33vh;
  left: 70vw;
}

.step805 {
  position: absolute;
  top: 50vh;
  left: 70vw;
}

.step806 {
  position: absolute;
  top: 50vh;
  left: 70vw;
}

.step807 {
  position: absolute;
  top: 50vh;
  left: 70vw;
}

.step808 {
  position: absolute;
  top: 50vh;
  left: 70vw;
}

.step809 {
  position: absolute;
  top: 50vh;
  left: 70vw;
}

.step810 {
  position: absolute;
  top: 55vh;
  left: 70vw;
}

.step811 {
  position: absolute;
  top: 55vh;
  left: 73vw;
}

.step812 {
  position: absolute;
  top: 55vh;
  left: 73vw;
}

.step813 {
  position: absolute;
  top: 55vh;
  left: 73vw;
}

.step814 {
  position: absolute;
  top: 55vh;
  left: 73vw;
}

.step815 {
  position: absolute;
  top: 55vh;
  left: 73vw;
}

.step816 {
  position: absolute;
  top: 55vh;
  left: 73vw;
}

.step817 {
  position: absolute;
  top: 55vh;
  left: 73vw;
}

.step818 {
  position: absolute;
  top: 55vh;
  left: 73vw;
}

.step819 {
  position: absolute;
  top: 55vh;
  left: 73vw;
}

.step820 {
  position: absolute;
  top: 55vh;
  left: 73vw;
}

.step821 {
  position: absolute;
  top: 55vh;
  left: 73vw;
}

.step821 {
  position: absolute;
  top: 55vh;
  left: 73vw;
}

.step822 {
  position: absolute;
  top: 55vh;
  left: 73vw;
}

.step823 {
  position: absolute;
  top: 55vh;
  left: 73vw;
}

.tip-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

</style>
